import React from 'react'
import { PrimaryButton } from '@/Components/Button'
import TextInput from '@/Components/Form/TextInput'
import { Head, Link, useForm } from '@inertiajs/react'
import { ErrorMessage, Field, FieldGroup, Label } from '@/Components/Form/Fieldset'
import SimpleCheckbox from '@/Components/Form/SimpleCheckbox'
import GuestLayout from '@/Layouts/GuestLayout'

export default function Register() {
    const form = useForm({
        tax_consultant_name: '',
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
    })

    const submit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault()

        form.post(route('register'), {
            onFinish: () => form.reset('password', 'password_confirmation'),
        })
    }

    return (
        <>
            <Head title="Steuerberater-Registrierung" />

            <div>
                <div className={'text-lg'}>Kostenlosen Kanzlei-Account erstellen</div>
                <div className={'text-sm text-stone-700'}>Erstelle jetzt einen Account für deine Steuerberatungskanzlei</div>
            </div>

            <form onSubmit={submit} className={'mt-6'}>
                <FieldGroup>
                    <Field>
                        <Label htmlFor="tax_consultant_name" value="Name deiner Kanzlei" />

                        <TextInput
                            id="tax_consultant_name"
                            value={form.data.tax_consultant_name}
                            className="block w-full"
                            isFocused={true}
                            onChange={(e) => form.setData('tax_consultant_name', e.target.value)}
                            required
                        />

                        <ErrorMessage message={form.errors.tax_consultant_name} />
                    </Field>

                    <Field>
                        <Label htmlFor="name" value="Dein Name" />

                        <TextInput
                            id="name"
                            name="name"
                            value={form.data.name}
                            className="block w-full"
                            autoComplete="name"
                            onChange={(e) => form.setData('name', e.target.value)}
                            required
                        />

                        <ErrorMessage message={form.errors.name} />
                    </Field>

                    <Field>
                        <Label htmlFor="email" value="Email" />

                        <TextInput
                            id="email"
                            type="email"
                            name="email"
                            value={form.data.email}
                            autoComplete={'email'}
                            onChange={(e) => form.setData('email', e.target.value)}
                            className="block w-full"
                            required
                        />
                    </Field>

                    <Field>
                        <Label htmlFor="password" value="Passwort" />

                        <TextInput
                            id="password"
                            type="password"
                            name="password"
                            value={form.data.password}
                            className="block w-full"
                            autoComplete="new-password"
                            onChange={(e) => form.setData('password', e.target.value)}
                            required
                        />

                        <ErrorMessage message={form.errors.password} />
                    </Field>

                    <Field>
                        <Label htmlFor="password_confirmation" value="Passwort bestätigen" />

                        <TextInput
                            id="password_confirmation"
                            type="password"
                            name="password_confirmation"
                            value={form.data.password_confirmation}
                            className="block w-full"
                            autoComplete="new-password"
                            onChange={(e) => form.setData('password_confirmation', e.target.value)}
                            required
                        />

                        <ErrorMessage message={form.errors.password_confirmation} />
                    </Field>

                    <Field>
                        <SimpleCheckbox
                            label={'Ich akzeptiere die <a class="underline" target="_blank" href="' + route('terms-of-service') + '">AGB</a>'}
                            required
                        />
                    </Field>
                </FieldGroup>

                <div className="mt-4 flex items-center justify-end">
                    <Link
                        href={route('login')}
                        className="rounded-md text-sm text-gray-600 underline hover:text-gray-900 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
                    >
                        Bereits registriert?
                    </Link>

                    <PrimaryButton className="ms-4" disabled={form.processing}>
                        Kanzlei-Account erstellen
                    </PrimaryButton>
                </div>
            </form>
        </>
    )
}

Register.layout = (page: React.ReactElement) => <GuestLayout children={page} />
